<template>
	<div>
		<div class="doctorPage doctorSeach managerPlan">
			<div class="selectSearch">
				<el-form ref="preservationform" :model="exportStatiscsParamters" class="qcFrom" :inline="true">
					<el-form-item label="关键词">
						<el-input v-model="exportStatiscsParamters.keyword" class="name" placeholder="名称/专家组/方案" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="类型" prop="category">
						<el-select size="small" v-model="exportStatiscsParamters.category" placeholder="请选择类型">
							<el-option v-for="item in detailsRulesParameter.types" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
							<el-option label="全部" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="中心列表">
						<el-select v-model="exportStatiscsParamters.hospitalGuid" filterable placeholder="请选择中心" size="mini" class="name">
							<el-option label="全部" value=""></el-option>
							<el-option v-for="item in allHospitalsData.Hospitals" :key="item.HospitalGuid" :label="item.HospitalName" :value="item.HospitalGuid">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker class="time mar4" v-model="pickerDate" @change="datePicker" type="monthrange" size="mini"
						 range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy/MM" format="yyyy-MM"></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="search" round>查询</el-button>
					</el-form-item>
					<a href="javascript:;" @click="exportReportOld" class="addbtn addbtn-old" v-if="exportStatiscsList.SamplingTasks&&exportStatiscsList.SamplingTasks.length > 0">评估报告导出</a>
					<a href="javascript:;" @click="exportReport" class="addbtn" v-if="exportStatiscsList.SamplingTasks&&exportStatiscsList.SamplingTasks.length > 0">评估报告导出2.0</a>
				</el-form>
			</div>
			<!-- 中间内容 -->
			<div class="centerHome">
				<div class="ccHomel">
					<div class="compentTable">
						<el-table class="qcTable" ref="exportStatiscsref" :data="exportStatiscsList.SamplingTasks" show-overflow-tooltip v-loading="loading" :row-key="getExportkey" @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="80" :reserve-selection="true"></el-table-column>
							<el-table-column prop="Id" label="任务编号" min-width="100"></el-table-column>
							<el-table-column prop="Name" label="名称"></el-table-column>
							<el-table-column prop="CategoryName" min-width='90' label="抽样类型">
								<template slot-scope="scope">
									<span v-if="scope.row.CategoryName=='影像'" title="影像">影像</span>
									<span v-else-if="scope.row.CategoryName=='报告'" title="报告">报告</span>
									<span v-else title="影像和报告">影像和报告</span>
								</template>
							</el-table-column>
							<el-table-column prop="QCPlanName" label="评分方案"></el-table-column>
							<el-table-column prop="Progress" label="报告总数">
								<template slot-scope="scope">
									<span>{{scope.row.Progress.split('/')[1]}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="CreateDt" :formatter="formattertime" width='100' label="创建时间"></el-table-column>
							<el-table-column prop="ComepleteDt" width='100' :formatter="formattertime" label="完成时间"></el-table-column>
							<el-table-column prop="CreateorName" label="创建人"></el-table-column>
						</el-table>
						<div class="pages">
							<el-pagination class="pageAll" layout="prev, pager, next" :total="exportStatiscsList.TotalCount" :page-size='exportStatiscsParamters.PageCount' :current-page='exportStatiscsParamters.page' @current-change='currentChange'>
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog 
			title="云质控报告导出2.0"
			:visible.sync="exportVisible"
			width="580px" 
			class="files-export-dialog"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
		>
			<template #footer>
				<el-button  @click="exportVisible = false">取消</el-button>
				<Button type="primary" :is-debounce="true" @click="confirmExport">确定</Button>
			</template>
			<el-form ref="formRef" :model="formValues" :rules="formRules" label-width='110px' class="qcFrom">
				<el-form-item label="导出名称" prop="name">
					<el-input v-model="formValues.name" class="name" size="mini" placeholder="请输入导出名称"></el-input>
				</el-form-item>
				<el-form-item label="分配方法" prop="exportType">
					<el-radio-group v-model="formValues.exportType">
						<el-radio 
							v-for="(item, index) in exportTypeOptions" 
							:key="index"
							:label="item.value"
							:disabled="item.disabled"
						>
							{{ item.label }}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="对比任务" prop="exportType">
					<el-select v-model="formValues.hospitalGuid" filterable placeholder="请选择对比任务机构" size="mini" class="name" @change="getCompareTaskList">
						<el-option v-for="item in allHospitalsData.Hospitals" :key="item.HospitalGuid" :label="item.HospitalName" :value="item.HospitalGuid">
						</el-option>
					</el-select>
					<el-date-picker 
						class="time mar4" 
						style="width: 320px;"
						v-model="formValues.pickerDate" 
						@change="getCompareTaskList" 
						type="monthrange" 
						size="mini" 
						range-separator="至" start-placeholder="开始时间" 
						end-placeholder="结束时间" 
						value-format="yyyy/MM" 
						format="yyyy-MM">
					</el-date-picker>
					<el-select v-model="formValues.compareTask" placeholder="请选择对比任务" size="mini" class="name" multiple filterable @change="handleCompareTaskChange">
						<el-option v-for="item in compareTaskList" :key="item.SamplingTaskGuid" :label="item.Id+'-'+item.Name" :value="item.SamplingTaskGuid"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog 
			title="云质控报告导出"
			:visible.sync="exportVisibleOld"
			width="580px" 
			class="files-export-dialog"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
		>
			<template #footer>
				<el-button  @click="exportVisibleOld = false">取消</el-button>
				<Button type="primary" :is-debounce="true" @click="confirmExportOld">确定</Button>
			</template>
			<el-form ref="formRef" :model="formValues" :rules="formRules" label-width='110px' class="qcFrom">
				<el-form-item label="导出名称" prop="name">
					<el-input v-model="formValues.name" class="name" size="mini" placeholder="请输入导出名称"></el-input>
				</el-form-item>
				<el-form-item label="分配方法" prop="exportType">
					<el-radio-group v-model="formValues.exportType">
						<el-radio 
							v-for="(item, index) in exportTypeOptions" 
							:key="index"
							:label="item.value"
							:disabled="item.disabled"
						>
							{{ item.label }}
						</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import Api from '../../api'
	import axios from '@/js/api'
	import Button from '@/components/Common/Button/index'
	export default {
		components: { Button },
		data() {
			return {
				exportreportList:[],
				pickerDate: [],
				getExportkey(row) {
					return row.SamplingTaskGuid
				},
				exportList:[],
				exportVisible: false,
				exportVisibleOld: false,
				formValues: {
					name: '',
					exportType: 0,
					pickerDate: [],
					compareTask: [],
					hospitalGuid:''
				},
				formRules: {
					name: [{ required: true, message: '请填写导出名称', trigger: 'blur' }],
					exportType: [{ required: true, message: '请选择导出类型', trigger: 'blur' }]
				},
				exportTypeOptions: [
					{ label: '按月导出', value: 0 },
					{ label: '按季度导出', value: 5, disabled: true },
					{ label: '按年导出', value: 10, disabled: true }
				],
				compareTaskList: []
			}
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['loading','detailsRulesParameter','allHospitalsData']),
			...Vuex.mapState('managerPlanList', ['exportStatiscsParamters', 'exportStatiscsList']),
		},
		activated() {
			this.exportStatiscsParamters.pageIndex = 1;
			this.pickerDate.push(this.exportStatiscsParamters.startDate);
			this.pickerDate.push(this.exportStatiscsParamters.endDate);
			this.GetTaskList();
			this.getAllHospitals({
				enable: -1,
				name: '',
				pageIndex:1,
				pageCount: 999999
			})
		},
		methods: {
			...Vuex.mapActions('managerPlanList', ['GetTaskList']),
			...Vuex.mapActions('breadcrumb', ['getAllHospitals', 'setLoading']),
			datePicker(event) {
				if(event){
					this.exportStatiscsParamters.startDate = event[0];
					this.exportStatiscsParamters.endDate = event[1];
				}else{
					this.clearDate();
				}
			},
			clearDate(){
				this.exportStatiscsParamters.startDate = '';
				this.exportStatiscsParamters.endDate = '';
			},
			search() {
				this.exportStatiscsParamters.pageIndex = 1;
				this.$refs.exportStatiscsref.clearSelection();
				this.exportList = [];
				this.GetTaskList();
			},
			getCompareTaskList(){
				axios.ajaxGet('get',Api.api.experts.ExportGetTaskList,{
					hospitalGuid: this.formValues.hospitalGuid,
					startDate: this.formValues.pickerDate && this.formValues.pickerDate.length > 0 ? this.formValues.pickerDate[0] : '',
					endDate: this.formValues.pickerDate && this.formValues.pickerDate.length > 0 ? this.formValues.pickerDate[1] : '',
					pageIndex:1,
					pageCount:999999
				}).then(res=>{
					if(res.data && res.data.SamplingTasks && res.data.SamplingTasks.length > 0){
						this.compareTaskList = res.data.SamplingTasks;
					}else{
						this.compareTaskList = [];
					}
				})
			},
			//分页
			currentChange(val) {
				this.exportStatiscsParamters.pageIndex = val;
				this.GetTaskList();
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			// 选择任务
			handleSelectionChange(row){
				this.exportList = row.map(item => item.SamplingTaskGuid)
				this.exportreportList = row
			},
			formattertime(row, column, cellValue) {
				if (cellValue != '' && cellValue != null) {
					return cellValue.substring(0, cellValue.length - 3);
				} else {
					return cellValue;
				}
			},
			// 显示导出弹窗
			exportReport(){
				if (this.exportStatiscsParamters.hospitalGuid!= ''&&this.exportList.length>0) {
					const name = this.allHospitalsData.Hospitals.find(item => item.HospitalGuid === this.exportStatiscsParamters.hospitalGuid)
					const currentlist = this.exportreportList
					
					let nameDate = []
					for (let i = 0; i < currentlist.length; i++) {
						const element = currentlist[i];
						let date = new Date(element.CreateDt);
						nameDate.push(`${date.getFullYear(element.CreateDt)}年${date.getMonth(element.CreateDt)+1}月`)
					}
					
					this.formValues = {
						name: `${name.HospitalName}${this.dataSort(nameDate).join(',')}`,
						exportType: 0,
						pickerDate: [],
						compareTask: [],
						hospitalGuid: ''
					}
					this.exportVisible = true
				}else if(this.exportList.length<=0){
					this.$message.error('请先选择任务'); 
				}else{
					this.$refs.exportStatiscsref.clearSelection();
					this.$message.error('请先选择中心'); 
				}
			},
			exportReportOld(){
				if (this.exportStatiscsParamters.hospitalGuid!= ''&&this.exportList.length>0) {
					const name = this.allHospitalsData.Hospitals.find(item => item.HospitalGuid === this.exportStatiscsParamters.hospitalGuid)
					const currentlist = this.exportreportList
					
					let nameDate = []
					for (let i = 0; i < currentlist.length; i++) {
						const element = currentlist[i];
						let date = new Date(element.CreateDt);
						nameDate.push(`${date.getFullYear(element.CreateDt)}年${date.getMonth(element.CreateDt)+1}月`)
					}
					
					this.formValues = {
						name: `${name.HospitalName}${this.dataSort(nameDate).join(',')}`,
						exportType: 0,
						pickerDate: [],
						compareTask: [],
						hospitalGuid: ''
					}
					this.exportVisibleOld = true
				}else if(this.exportList.length<=0){
					this.$message.error('请先选择任务'); 
				}else{
					this.$refs.exportStatiscsref.clearSelection();
					this.$message.error('请先选择中心'); 
				}
			},
			dataSort(dateStrings){
				// 将日期字符串转换为 Date 对象
				let dateObjects = dateStrings.map(dateString => {
					// 使用正则表达式提取年份和月份
					let match = dateString.match(/(\d{4})年(\d{1,2})月/);
					if (match) {
						let year = parseInt(match[1]);
						let month = parseInt(match[2]) - 1; // 月份在Date对象中是从0开始的
						return new Date(year, month);
					} else {
						return null; // 处理无效日期的情况
					}
				});

				// 去除无效日期
				dateObjects = dateObjects.filter(date => date !== null);

				// 按照日期排序
				dateObjects.sort((a, b) => a - b);

				// 将排序后的 Date 对象转换回字符串
				let sortedDateStrings = dateObjects.map(date => {
					let year = date.getFullYear();
					let month = date.getMonth() + 1; // 因为月份在正则表达式中减了1，这里需要加回去
					return `${year}年${month}月`;
				});
				return [...new Set(sortedDateStrings)]
			},
			// 处理对比任务选择变化，限制选择数量不超过已选任务数量
			handleCompareTaskChange(value) {
				if (!value || !Array.isArray(value)) {
					return;
				}
				const maxCount = this.exportList.length;
				if (maxCount > 0 && value.length > maxCount) {
					// 如果选择数量超过限制，截取到最大数量
					this.formValues.compareTask = value.slice(0, maxCount);
					this.$message.warning(`对比任务最多只能选择 ${maxCount} 个`);
				}
			},
			// 确认导出
			confirmExport() {
				this.$refs.formRef.validate((valid) => {
					if (!valid) return
					if(this.formValues.compareTask.length < this.exportList.length ){
						this.$message.warning(`对比任务请选择 ${this.exportList.length} 个`);
						return;
					}
					let samplingTaskGuids = this.exportList.join(',');
					let pastTaskIds = this.formValues.compareTask.join(',');
					const { name, exportType } =  this.formValues
					const action = axios.exportExcel(Api.api.experts.HospitalQCReport2)
					const params = `?samplingTaskGuids=${samplingTaskGuids}&hospitalGuid=${this.exportStatiscsParamters.hospitalGuid}&docName=${name}&scopeType=${exportType}&pastTaskIds=${pastTaskIds}`
					this.exportVisible = false
					// window.location.href = action + params
					window.open(action + params)
				});
			},
			confirmExportOld() {
				this.$refs.formRef.validate((valid) => {
					if (!valid) return
					const { name, exportType } =  this.formValues
					const action = axios.exportExcel(Api.api.experts.HospitalQCReport)
					const params = `?samplingTaskGuids=${this.exportList.join(',')}&hospitalGuid=${this.exportStatiscsParamters.hospitalGuid}&docName=${name}&scopeType=${exportType}`
					this.exportVisible = false
					// window.location.href = action + params
					window.open(action + params)
				});
			}
		}
	}
</script>
<style lang="scss" scoped="scoped">
	.addbtn-old{
		right:140px !important;
	}
	.doctorPage>>>.el-input__prefix{
		width: 92%;
	}
	.selectSearch{
		padding-right: 130px;
	}
	::v-deep .files-export-dialog {
		.el-dialog__footer {
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.el-dialog__body {
			padding: 15px 40px;
		}
		.el-form {
			border-radius: 6px;
			border: 1px solid transparent;
			padding-top: 20px;
			padding-bottom: 40px;
			.el-form-item {
				margin-bottom: 10px;
				.el-form-item__content {
					.name {
						width: 320px;
						.el-input__inner {
							border-radius: 16px;
						}
					}
				}
			}
		}
	}
</style>
